<template>
    <div class="d-flex flex-row">
        <mini-relative-date :value.sync="from"></mini-relative-date>
        <i class="fa-solid fa-arrow-right m-auto text-info"></i>
        <mini-relative-date :value.sync="to" ></mini-relative-date>
    </div>
</template>

<script>
import MiniRelativeDate from "@/components/common/inputs/MiniRelativeDate.vue";
import valueMixin from "@/components/common/inputs/mixin/value-mixin";

export default {
    name: "MiniRelativeDateRange",
    components: {MiniRelativeDate},
    mixins: [valueMixin],
    props: {
        toJson: Boolean,
    },
    data() {
        return {
            from: null,
            to: {
                relative: 'Now'
            },
        }
    },
    computed: {
        config() {
            return {
                from: this.from,
                to: this.to,
            }
        },
    },
    watch: {
        config() {
            if (this.toJson) {
                this.localValue = JSON.stringify(this.config);
            } else {
                this.localValue = this.config;
            }
        },
    },
    methods: {
        handleValue() {
            let temp = this.value;
            if (temp) {
                if (typeof temp === 'string') {
                    if (temp.startsWith('{')) {
                        temp = JSON.parse(temp);
                    } else {
                        return;
                    }
                }
                this.from = temp.from;
                this.to = temp.to;
            }
        },
    }
}
</script>

<style scoped>

</style>
